// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServiceAttributes_SalvarAtributosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/additional_service_attributes/salvar_atributos/{additional_service_id}
 *
 * Bulk replace attribute bindings for an additional service.
 *
 * Required:
 *   - attributes (So_CategoryAttributeBindingInputRow[]) — each entry must
 *     contain attribute_id; required, display_order and is_description
 *     default to 0.
 */
import type { So_CategoryAttributeBindingInputRow } from './So_CategoryAttributeBindingInputRow'
import { registerContract } from './validate'

export interface AdditionalServiceAttributes_SalvarAtributosInput {
attributes?: So_CategoryAttributeBindingInputRow[]
}

registerContract('AdditionalServiceAttributes_SalvarAtributosInput', {
  attributes: {
    type: 'array',
    required: false,
    items: {
      attribute_id:   { type: 'number',  required: true },
      required:       { type: 'number',  required: false },
      display_order:  { type: 'number',  required: false },
      report_type:    { type: 'string',  required: false },
      is_description: { type: 'number',  required: false },
    },
  },
})
